// 字符串截取
export function stringSlice(str, start, end) {
  if (str.length <= end + 1) {
    return str;
  }
  return str.substring(start, end) + "...";
}

/**
 * 对象转地址栏参数
 * @param {Object} obj 对象
 * @param {String} query 转成的地址参数串
 */
export function queryStringify(obj, isEncode = true) {
  let query = "";
  for (let o in obj) {
    if (typeof obj[0] == "object") {
      query += "&" + queryStringify(obj[o]);
    } else {
      if (isEncode) {
        query += `&${o}=${encodeURI(obj[o])}`;
      } else {
        query += `&${o}=${obj[o]}`;
      }
    }
  }
  query = query.substr(1);
  return query;
}

/**
 * @description: 获取url 参数
 * @param {string} url 页面地址
 * @return {object}
 */
export const getURLQuery = url => {
  const uri = decodeURI(url);
  return (uri.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => (
      (a[v.slice(0, v.indexOf("="))] = v.slice(v.indexOf("=") + 1)), a
    ),
    {}
  );
};

/**
 * @description: 格式化时间
 * @param {string|number} duration 时长
 * @param {hh:mm:ss|mm:ss} fmt 格式(目前只有两种 hh:mm:ss mm:ss)
 * @return {string}
 */
export const formatTime = (duration = 0, fmt = "mm:ss") => {
  let hasHour = false;
  if (/(h+)/.test(fmt)) {
    hasHour = true;
  }

  // 至少两位
  const fixed2 = num => (num >= 10 ? num : `0${num}`);

  const d = Math.ceil(duration);
  const s = d % 60; // 秒
  let m = parseInt(d / 60); // 分
  let h = 0; // 时
  if (hasHour) {
    h = parseInt(d / (60 * 60)); // 小时
    m = m - h * 60; // 如果要显示小时需要重新更新分

    return `${fixed2(h)}:${fixed2(m)}:${fixed2(s)}`;
  }

  return `${fixed2(m)}:${fixed2(s)}`;
};

/**
 * @description: 新建下载
 * @param {object} options
 * @return {void}
 */
export const createDownload = options => {
  const { download_url, download_title } = options

  var xhr = new XMLHttpRequest()
  xhr.open("GET", download_url, true)
  xhr.responseType = "blob"
  xhr.onload = function() {
    var urlCreator = window.URL || window.webkitURL
    var url = urlCreator.createObjectURL(this.response)
    var tag = document.createElement("a")
    tag.href = url
    tag.target = "_blank"
    tag.download = `${download_title}`
    document.body.appendChild(tag)
    tag.click()
    document.body.removeChild(tag)
  }
  xhr.send()
}



// WEBPACK FOOTER //
// ./pc/yiqijian-video/utils/index.js